import { DataGrid } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import { DeviceService } from "../../services/DataService"
import TimeUtils from "../../utils/TimeUtils"
import { TestResultBox } from "./TestResultBox"
import { Translate, translate } from "react-i18nify"
import { AccordionDetails, Accordion, AccordionSummary, Box } from "@material-ui/core"
import { Typography } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export const TestResultTable = ({udsn, from, to, gridWidth}) => {
    const [testResults, setTestResults] = useState([])
    
    useEffect(() => {
        DeviceService.getTestResultsByUdsn(udsn, from ?? 0, to ?? 0).then((result) => {
            setTestResults(result.data)
        }).catch((err) => {
            console.error(err)
        });
    },[])

    const columns = [
        {
            field: 'timestamp', headerName: translate('Timestamp'), minWidth:150, flex: 1,
            valueGetter: (results) => {
                return TimeUtils.utcToLocal(results.row.submitUnixTimestamp, true)
            }
        },
        {
            field: 'testProtocol', headerName: translate('TestProtocol'), minWidth:150, flex: 3,
            valueGetter: (results) => {
                return results.row.testProtocol
            }
        },
        {
            field: 'user', headerName: translate('user'), minWidth:150, flex: 1,
            valueGetter: (results) => {
                return  `${results.row.username} (${results.row.userId})`
            }
        },
        {
            field: 'passed', headerName: translate('Passed'), minWidth:100, flex: 1,
            valueGetter: (results) => {
                return results.row.passed
            },
            renderCell: (results) => {
                return (
                    <TestResultBox testResult={results.row}/>
                )
            }
        }
    ]

    return(
        <Box id="TestResultTable" >
            <DataGrid
                ColumnWidth="*"
                overflowY="auto"
                sx={{ height: 480, width: gridWidth }}
                columns={columns}
                rows={testResults}
                getRowId={(row) => {
                    return row.id
                }}
            />
        </Box>
    )
}